// Copyright (c) 2017 Deere & Company

import ProductRegistration from '../../product/product-registration/components';

export default {
    component: ProductRegistration,
    name: 'PRODUCT_REGISTRATION',
    path: 'register-product'
};



// WEBPACK FOOTER //
// ./src/routes/products/product-registration.js